/* eslint-disable radix */
import React from 'react';

import { FormControlLabel, makeStyles, Radio, RadioGroup, Typography } from '@material-ui/core';
import moment from 'moment';

const useStyles = makeStyles(() => {
  return {
    typographyStudyDate: {
      color: '#999999',
      fontSize: '14px',
    },
    typographyStudyTitle: {
      color: '#172B4D',
      textAlign: 'left',
    },
    typographyStudyTitleEmpty: {
      color: '#999999',
      textAlign: 'left',
    },
    typographyTitle: {
      color: '#999999',
      lineHeight: '18px',
      margin: '12px 0px',
      textAlign: 'left',
    },
  };
});

export default ({ studies = [], selectedStudyId = null, onSelectStudy }) => {
  const classes = useStyles();

  const handleSelectStudy = (e) => {
    if (onSelectStudy) onSelectStudy(e.target.value);
  };

  const renderStudy = () => {
    return (
      <RadioGroup onChange={handleSelectStudy} value={parseInt(selectedStudyId)}>
        {studies.map((study) => {
          const title = study?.title || study?.description;
          const titleClass = title ? classes.typographyStudyTitle : classes.typographyStudyTitleEmpty;
          const dateString = study.createdAt ? moment(study.createdAt).format('MMMM Do YYYY, h:mm a') : '';
          const labelSetup = (
            <div>
              <span className={titleClass}>{study?.title || study?.description || 'No Title'}</span>{' '}
              {dateString && (
                <>
                  &nbsp;- <span className={classes.typographyStudyDate}>{dateString}</span>
                </>
              )}
            </div>
          );

          const studyId = parseInt(study.id);

          return <FormControlLabel key={study.id} control={<Radio color="primary" />} value={studyId} label={labelSetup} />;
        })}
      </RadioGroup>
    );
  };

  return (
    <>
      <Typography className={classes.typographyTitle}>Select a study</Typography>
      {renderStudy()}
    </>
  );
};
